import React, { FunctionComponent } from 'react';
import styles from './Gallery.module.scss';
import { Block, BlockContent, ResponsiveImage, Typography } from 'components/elements';
import { WPAcfGallery } from 'types/acf/gallery';
import clsx from 'clsx';
import DOMPurify from 'dompurify';

interface OwnProps {
  data: WPAcfGallery | null;
}

type GalleryProps = JSX.IntrinsicElements['div'] & OwnProps;

const Gallery: FunctionComponent<GalleryProps> = props => {
  const { data: galleryData } = props;

  if (!galleryData) {
    return null;
  }

  const { header, images } = galleryData;

  return (
    <Block id="gallery" theme="white" data-module="gallery">
      <BlockContent>
        <div className={styles.wrapper}>
          {header && (
            <Typography
              mobile="new_neue_semibold_26"
              tablet="new_neue_semibold_26"
              desktop="new_neue_32_h1"
              as="h4"
              className={styles.header}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(header) }}
            />
          )}
          <div className={styles.images}>
            {images?.map(({ type, image }, index) => {
              const imageClassNames = clsx({
                [styles.image]: true,
                ...(type && { [styles[type]]: true }),
              });

              if (!image) {
                return null;
              }

              return (
                <div key={`gallery-image-${index}`} className={imageClassNames}>
                  {
                    <ResponsiveImage
                      desktopImage={{ config: image, imgProps: { componentHeight: true } }}
                      mobileImage={{ config: image, imgProps: { componentHeight: true } }}
                    />
                  }
                </div>
              );
            })}
          </div>
        </div>
      </BlockContent>
    </Block>
  );
};

export default Gallery;
